(() => {
  document.querySelectorAll('.res-form-revendedor').forEach((section) => {
    const form     = section.querySelector('.res-form');
    if (!form) return;

    const steps    = form.querySelectorAll('.res-form__step');
    const btnNext  = form.querySelector('.res-form__btn-next');
    const btnBack  = form.querySelector('.res-form__btn-back');

    // ── Masks ──────────────────────────────────────────────

    form.querySelectorAll('.js-mask-cnpj').forEach((el) => {
      el.addEventListener('input', () => {
        let v = el.value.replace(/\D/g, '').slice(0, 14);
        if (v.length > 12) v = v.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2})/, '$1.$2.$3/$4-$5');
        else if (v.length > 8) v = v.replace(/^(\d{2})(\d{3})(\d{3})(\d{0,4})/, '$1.$2.$3/$4');
        else if (v.length > 5) v = v.replace(/^(\d{2})(\d{3})(\d{0,3})/, '$1.$2.$3');
        else if (v.length > 2) v = v.replace(/^(\d{2})(\d{0,3})/, '$1.$2');
        el.value = v;
      });
    });

    form.querySelectorAll('.js-mask-phone').forEach((el) => {
      el.addEventListener('input', () => {
        let v = el.value.replace(/\D/g, '').slice(0, 11);
        if (v.length > 6) v = v.replace(/^(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
        else if (v.length > 2) v = v.replace(/^(\d{2})(\d{0,5})/, '($1) $2');
        else if (v.length > 0) v = v.replace(/^(\d{0,2})/, '($1');
        el.value = v;
      });
    });

    form.querySelectorAll('.js-mask-uf').forEach((el) => {
      el.addEventListener('input', () => {
        el.value = el.value.replace(/[^a-zA-Z]/g, '').toUpperCase().slice(0, 2);
      });
    });

    // ── Checkboxes → hidden input ──────────────────────────

    const checks      = form.querySelectorAll('.js-tipo-check');
    const hiddenTipo  = form.querySelector('.js-tipo-hidden');

    const syncTipo = () => {
      const selected = [...checks]
        .filter((c) => c.checked)
        .map((c) => c.value)
        .join(', ');
      if (hiddenTipo) hiddenTipo.value = selected;
    };

    checks.forEach((c) => c.addEventListener('change', syncTipo));

    // ── Step navigation ────────────────────────────────────

    const goTo = (index) => {
      steps.forEach((s, i) => s.classList.toggle('hidden', i !== index));
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const validateStep = (stepEl) => {
      const required = stepEl.querySelectorAll('[required]');
      let valid = true;
      required.forEach((el) => {
        if (!el.value.trim()) {
          el.focus();
          el.style.borderColor = '#e53935';
          valid = false;
        } else {
          el.style.borderColor = '';
        }
      });
      return valid;
    };

    if (btnNext) {
      btnNext.addEventListener('click', () => {
        if (validateStep(steps[0])) goTo(1);
      });
    }

    if (btnBack) {
      btnBack.addEventListener('click', () => goTo(0));
    }
  });
})();
